// Reports module route constants

export const REPORTS_BASE_ROUTE = '/analytics/reports';
export const REPORTS_PERFORM_SPARK_ROUTE = '/analytics/reports/perform-spark';

// Route matchers for tab active state detection
export const REPORTS_PERFORM_SPARK_ROUTES = [
  REPORTS_PERFORM_SPARK_ROUTE,
] as const;

export const REPORTS_CUSTOM_ROUTE = '/analytics/reports/configure';
export const REPORTS_CUSTOM_ROUTES = [REPORTS_CUSTOM_ROUTE] as const;

export const REPORTS_REPORT_BUILDER_ROUTE = '/analytics/report-builder';
export const REPORTS_REPORT_BUILDER_NEW_ROUTE = '/analytics/report-builder/new';
export const REPORTS_REPORT_BUILDER_VIEW_ROUTE = '/analytics/report-builder/:id';
export const REPORTS_REPORT_BUILDER_EDIT_ROUTE = '/analytics/report-builder/:id/edit';
export const REPORTS_REPORT_BUILDER_CLASSIC_ROUTE = '/analytics/report-builder/classic';
export const REPORTS_REPORT_BUILDER_ROUTES = [
  REPORTS_REPORT_BUILDER_ROUTE,
  REPORTS_REPORT_BUILDER_NEW_ROUTE,
  REPORTS_REPORT_BUILDER_CLASSIC_ROUTE,
] as const;

// Legacy route constant - for backwards compatibility
export const REPORTS_PERFORMANCE_MANAGEMENT_ROUTE = '/analytics/reports/performance-management';
export const REPORTS_PERFORMANCE_MANAGEMENT_ROUTES = [
  REPORTS_PERFORMANCE_MANAGEMENT_ROUTE,
  '/analytics/reports/perform-spark',
] as const;
